<script setup>
import {useBaseStore} from "~/stores/base";
import Drawer from "~/components/Drawer.vue";

/** emits **/
const emits = defineEmits(["close"])

/** props **/
const props = defineProps({
  open: {
    default: false,
    required: true
  },
  product: {
    default: {},
    required: true
  },
  current: {
    default: 0,
    required: true
  },
})

/** data **/

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)
const currentColor = computed(() => props.product.newVariantOptions?.colorList[props.current].color)
const currentModels = computed(() => props.product.optionConfig?.find(config => config.name === currentColor.value).models)

/** watch **/

/** methods **/
const handleClose = () => {
  emits("close")
}

/** lifecycle **/

</script>

<template>
  <div class="popup-model-info-mobile" v-if="isMobile">
    <Drawer :open="open" :position="'bottom'" :border-radius="'8px 8px 0 0'" :border="'0.5px solid #B8AFAB'" @close="handleClose">
      <div class="drawer">
        <div class="title">
          <span>model info</span>
          <img src="@/assets/img/icon-close-black.svg" alt="close" @click="handleClose">
        </div>
        <div class="content">
          <div class="model" v-for="model in currentModels">
            <div class="name">
              Model {{ model.modelName }} is wearing <span class="bold">{{ model.wearingSize }}</span>
            </div>
            <div class="info">
              <div class="cell">
                <div class="left">Hips</div>
                <div class="right">{{ model.hips }}</div>
              </div>
              <div class="cell">
                <div class="left">Waist</div>
                <div class="right">{{ model.waist }}</div>
              </div>
              <div class="cell">
                <div class="left">Height</div>
                <div class="right">{{ model.height }}</div>
              </div>
              <div class="cell">
                <div class="left">Bust</div>
                <div class="right">{{ model.bust }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
  <div class="popup-model-info-desktop" v-if="!isMobile && open">
    <div class="title">
      <span>model info</span>
      <img src="@/assets/img/icon-close-black.svg" alt="close" @click="handleClose">
    </div>
    <div class="content">
      <div class="model" v-for="model in currentModels">
        <div class="name">
          Model {{ model.modelName }} is wearing <span class="bold">{{ model.wearingSize }}</span>
        </div>
        <div class="info">
          <div class="cell">
            <div class="left">Hips</div>
            <div class="right">{{ model.hips }}</div>
          </div>
          <div class="cell">
            <div class="left">Waist</div>
            <div class="right">{{ model.waist }}</div>
          </div>
          <div class="cell">
            <div class="left">Height</div>
            <div class="right">{{ model.height }}</div>
          </div>
          <div class="cell">
            <div class="left">Bust</div>
            <div class="right">{{ model.bust }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.popup-model-info-mobile {
  .drawer {
    width: 100vw;
    padding: 10px 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;

    .title {
      padding: 0 10px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 650;
      line-height: normal;
      text-transform: uppercase;

      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }

    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 14px;

      .model {
        width: 100%;

        .name {
          width: 100%;
          padding: 2px 10px;
          background-color: $color-BNTO-beige-light;
          font-family: "TWK Lausanne";
          font-size: 12px;
          font-style: normal;
          font-weight: 300;
          line-height: normal;
          text-align: center;

          .bold {
            font-family: "TWK Lausanne";
            font-size: 12px;
            font-style: normal;
            font-weight: 650;
            line-height: normal;
            margin-left: 8px;
          }
        }

        .info {
          margin-top: 12px;
          display: flex;
          flex-direction: column;
          gap: 10px;

          .cell {
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            font-family: "TWK Lausanne";
            font-size: 12px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;

            .left {

            }

            .right {

            }
          }
        }
      }
    }
  }
}

.popup-model-info-desktop {
  display: flex;
  width: 294px;
  padding: 10px 0px;
  flex-direction: column;
  align-items: center;
  gap: 14px;

  border-radius: 8px;
  border: 0.5px solid $color-BNTO-beige-dark;
  background: #FFF;
  box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.08);

  position: absolute;
  top: 30px;
  left: -10px;
  z-index: 1;

  .title {
    padding: 0 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 650;
    line-height: normal;
    text-transform: uppercase;

    img {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 14px;

    .model {
      width: 100%;

      .name {
        width: 100%;
        padding: 2px 10px;
        background-color: $color-BNTO-beige-light;
        font-family: "TWK Lausanne";
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: normal;
        text-align: center;

        .bold {
          font-family: "TWK Lausanne";
          font-size: 12px;
          font-style: normal;
          font-weight: 650;
          line-height: normal;
          margin-left: 8px;
        }
      }

      .info {
        margin-top: 12px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .cell {
          padding: 0 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          font-family: "TWK Lausanne";
          font-size: 12px;
          font-style: normal;
          font-weight: 300;
          line-height: normal;

          .left {

          }

          .right {

          }
        }
      }
    }
  }
}
</style>
